import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AssignToComponent } from './assign-to.component';
import { AutofocusDirectiveModule } from 'app/shared/directives/autoFocus/autofocus.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AutofocusDirectiveModule
  ],
  declarations: [AssignToComponent],
  exports: [AssignToComponent],
})
export class AssignToModule {}
